module.exports = __webpack_public_path__ + "img/svg/x.71428d426163ef05e621237bbc6c47fd.svg";